import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'

import { Icon20 } from 'builder/components/Icon'
import { InfoBox } from '../../elements/InfoBox/InfoBox'
import { useThemeConfig } from '../../hooks/useThemeConfig'
import { WidgetBox, WidgetImage, ActionButton } from '../../widget.styles'
import { WidgetProps } from '../../widget.types'
import { WidgetTheme } from '../../WidgetTheme'
import { SuccessBox } from '../../elements/SuccessBox/SuccessBox'
import { useInterviewsPracticedConfig } from './useInterviewsPracticedConfig'

export const InterviewsPracticed = ({ service }: WidgetProps) => {
  const { text, actionLink, image, status } = useInterviewsPracticedConfig({ service })
  const themeState = useThemeConfig({ service })
  const theme = themeState.initial
  const isCompleted = status === 'completed'

  const handleClick = () => {
    trackInternalEvent('progress_promo_cta_click', {
      score: service.title,
      cta: text.actionText,
    })
  }

  useEffect(() => {
    if (isCompleted) {
      trackInternalEvent('progress_score_completed', { score: service.title })
    }
  }, [isCompleted, service.title])

  return (
    <WidgetTheme theme={theme} tipOrder={service.widgetTipOrder}>
      <WidgetBox>
        <InfoBox text={text} isCompleted={isCompleted}>
          <ActionButton as={Link} to={actionLink} onClick={handleClick}>
            {text.actionText}
            <Icon20.ChevronRightRegular />
          </ActionButton>
        </InfoBox>
      </WidgetBox>
      <WidgetBox>
        {isCompleted ? <SuccessBox /> : <WidgetImage src={image} alt={text.imageAlt} />}
      </WidgetBox>
    </WidgetTheme>
  )
}
